<template>
  <div class="main">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <router-link to="/cms" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <h2>Entry Details</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-sm">
          <div class="label-value-unit">
            <div class="micro-label">title</div>
            <div class="value">{{ cmsData.title }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">blurb</div>
            <div class="value">{{ cmsData.blurb_one }}</div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">example file</div>
            <div class="value" v-if="cmsData.example_file">
              <span>{{ cmsData.example_file }}</span>
              <img :src="'http://localhost:8000/uploads/' + cmsData.example_file">
            </div>
            <div class="value" v-else>
              No file uploaded
            </div>
          </div>
        </div>
        <div class="col-sm d-flex flex-column align-items-start">
          <h5 class="mb-x1">Actions</h5>
          <router-link :to="'/cms/edit/' + cmsId" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1">
            <i class="fas fa-pen mr-x1"></i>Edit entry
          </router-link>
          <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline mb-x1" @click="verifyDelete = true">
            <i class="fas fa-trash mr-x1"></i>Delete this entry
          </button>
        </div>
      </div>
    </div>
    <!-- modal town -->
    <div class="modal-container" :class="{ 'show-modal' : verifyDelete }">
      <div class="modal-card">
        <h4>Delete this entry?</h4>
        <p class="mb-x4">This action cannot be undone.</p>
        <button class="zero-btn zero-btn-standard zero-btn-destructive zero-btn-outline width-100 mb-x2" @click="deleteEntry()">
          <i class="fas fa-trash mr-x1"></i>Delete this entry
        </button>
        <button class="zero-btn zero-btn-standard zero-btn-tertiary zero-btn-outline width-100" @click="verifyDelete = false">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const localApiURL = 'http://localhost:8000/'
// const remoteApiURL = 'https://timothyreeder.com/alpha/zero-api/public/api/cms'

const apiChoice = localApiURL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'cmsdetails',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      cmsId: '',
      cmsData: {
        'name': '',
        'blurb_one': '',
        'example_file': ''
      },
      verifyDelete: false
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.cmsid) {
      this.cmsId = this.$route.params.cmsid
      this.getEntry()
    }
  },
  methods: {
    getEntry () {
      axios
        .get(apiChoice + 'api/cms/' + this.cmsId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.cmsData = response.data
          // before data correction
          if (this.cmsData.example_file === 'none' || this.cmsData.example_file === 'null') {
            this.cmsData.example_file = null
          }
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    deleteEntry () {
      axios
        .delete(apiChoice + 'api/cms/' + this.cmsId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          console.log(response)
          this.$router.push({ path: '/cms' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
